import {
  TERMSCONDITIONS_CMS_DATA,
  SHOW_LOADER,
} from './TermsConditionsActionTypes';

const initialState = {
  termsConditionsCMSData: [],
  isLoader: false,
};

export const termsConditionsReducer = (state = initialState, action) => {
  if (action.type === TERMSCONDITIONS_CMS_DATA) {
    return {
      ...state,
      termsConditionsCMSData: action.payload,
    };
  } else if (action.type === SHOW_LOADER) {
    return {
      ...state,
      isLoader: action.isLoader,
    };
  } else {
    return state;
  }
};
